import { render, staticRenderFns } from "./TeacherInfoTable.vue?vue&type=template&id=c5e0a4f6&scoped=true"
import script from "./TeacherInfoTable.vue?vue&type=script&lang=js"
export * from "./TeacherInfoTable.vue?vue&type=script&lang=js"
import style0 from "./TeacherInfoTable.vue?vue&type=style&index=0&id=c5e0a4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e0a4f6",
  null
  
)

export default component.exports